import { authFeaturebase } from '@/integrations/featurebase/utils'
import IRClient from '@/modules/ir/apiClient'
import { EUserPortalMode, type FindexUser } from '@/types/models/user'
import { getUserFullName } from '@/utils/user'
import type { IAssetPreference } from 'findef'
import { defineStore, type _GettersTree } from 'pinia'

type UserType = FindexUser;//User & Partial<ISavedDocument<IUser, string>>

interface IUserStore {
  user: UserType
  token?: string
  portal: EUserPortalMode
  assetPreferences: IAssetPreference[]

  meta: {
    fetchedIrUser: boolean
    failedToFetchIRUser: boolean
  }
}

interface IUserStoreActions {
  init: () => Promise<void>
  refreshUser: () => Promise<void>
  refreshAssetPreferences: () => Promise<IAssetPreference[]>
  nextPortal: () => void
  setPortal: (portal: EUserPortalMode) => void
  setUser: (user: FindexUser) => void;
}

interface IUserStoreGetters extends _GettersTree<any> {
  fullname: () => string
  isIRAdmin: () => boolean
  isIRUser: () => boolean
  //  portfolio: () => ISavedDocument<IAsset, string>[]
}

export const useUserStore = defineStore<'user', IUserStore, IUserStoreGetters, IUserStoreActions>(
  'user',
  {
    state() {
      return {
        user: {
          _id: '_',
          firstname: '',
          lastname: '',
          email: '',
          color: '',
          opportunities: {
            enabled: false
          }
        },
        portal: window.location.pathname.startsWith('/investor-relations') ?  EUserPortalMode.IR_ADMIN : EUserPortalMode.DEFAULT,
        token: undefined,
        assetPreferences: [],
        meta: {
          fetchedIrUser: false,
          failedToFetchIRUser: false
        }
      }
    },
    getters: {
      isIRAdmin() {
        // return false;
        if (this.meta.failedToFetchIRUser === true) return false
        const user = this.user
        if (!user) return false
        if (!user.email && !user.authUserId) return false
        if (!user.administratedAssets) return false
        if (user.administratedAssets?.length <= 0) return false
        return true
      },
      isIRUser() {
        return true // This is always true now.

        //if (this.meta.failedToFetchIRUser === true) return false
        //const user = this.user
        //if (!user) return false
        //const isIRAdmin: boolean = this.isIRAdmin
        //if (isIRAdmin) return true
        //return !!user.authUserId
      },
      fullname() {
        return getUserFullName(this.user);
      }
    },
    actions: {
      async init() {
        console.log('fetching user...')
        await this.refreshUser()
        console.log('fetched user.')
      },
      setUser(user: FindexUser) {
        this.$patch(s => {
          s.user = user;
        });

        // Initialize featurebase asynchronously to avoid blocking
        if (user.emailVerified) {
          authFeaturebase(user).catch(e => {
            console.error('Failed to initialize featurebase:', e);
          });
        }
      },
      async refreshAssetPreferences() {
        const preferences = await IRClient.getAllAssetPreferences()
        this.$patch((s) => {
          s.assetPreferences = preferences
        })

        return preferences
      },
      async refreshUser() {
        try {
          const me = await IRClient.whoami()
          this.$patch((s) => {
            s.user = me
          });

        } catch (e) {
          console.error(e)
        }
      },
      nextPortal() {
        this.$patch((s) => {
          s.portal = ((s.portal + 1) % EUserPortalMode.__COUNT) as EUserPortalMode
        })
      },

      setPortal(portal: EUserPortalMode) {
        this.$patch((s) => {
          s.portal = portal
        })
      }
    }
  }
)
